/**
 * 年のバリデーション
 * @param {object} _ - フィールドの名前
 * @param {string} value - フィールドの値
 * @returns {Promise} バリデーション結果
 */
export const validateYear = (_, value) => {
  const currentYear = new Date().getFullYear();
  if (!value) {
    return Promise.reject("年を入力してください");
  } else if (value < 1900 || value > currentYear) {
    return Promise.reject(`年は1900から${currentYear}の間で入力してください`);
  }
  return Promise.resolve();
};

/**
 * 月のバリデーション
 * @param {object} _ - フィールドの名前
 * @param {string} value - フィールドの値
 * @returns {Promise} バリデーション結果
 */
export const validateMonth = (_, value) => {
  if (!value) {
    return Promise.reject("月を入力してください");
  } else if (value < 1 || value > 12) {
    return Promise.reject("月は1から12の間で入力してください");
  }
  return Promise.resolve();
};

/**
 * 日のバリデーション
 * @param {object} _ - フィールドの名前
 * @param {string} value - フィールドの値
 * @returns {Promise} バリデーション結果
 */
export const validateDay = (_, value) => {
  if (!value) {
    return Promise.reject("日を入力してください");
  } else if (value < 1 || value > 31) {
    return Promise.reject("日は1から31の間で入力してください");
  }
  return Promise.resolve();
};

/**
 * 電話番号のバリデーション
 * @param {object} _ - フィールドの名前
 * @param {string} value - フィールドの値
 * @returns {Promise} バリデーション結果
 */
export const validatePhoneNumber = (_, value) => {
  const phoneRegex = /^[0-9]{10,11}$/;
  if (!value) {
    // 空の場合は、バリデーションを通過させる
    return Promise.resolve();
  } else if (!phoneRegex.test(value)) {
    return Promise.reject("電話番号を正しく入力してください");
  }
  return Promise.resolve();
};

/**
 * メールアドレスのバリデーション
 * @param {object} rule - バリデーションルール
 * @param {string} value - フィールドの値
 * @returns {Promise} バリデーション結果
 */
export const validateEmail = (_, value) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!value) {
    // 空の場合は、バリデーションを通過させる
    return Promise.resolve();
  } else if (!emailRegex.test(value)) {
    return Promise.reject("メールアドレスを正しく入力してください");
  }
  return Promise.resolve();
};

/**
 * カタカナのバリデーション
 * @param {object} _ - フィールドの名前
 * @param {string} value - フィールドの値
 * @returns {Promise} バリデーション結果
 */
export const validateKana = (_, value) => {
  const kanaRegex = /^[\u30A0-\u30FF]+$/;
  if (!value) {
    // 空の場合は、バリデーションを通過させる
    return Promise.resolve();
  } else if (!kanaRegex.test(value)) {
    return Promise.reject("カタカナを入力してください");
  }
  return Promise.resolve();
};

/**
 * 郵便番号のバリデーション
 * @param {object} _ - フィールドの名前
 * @param {string} value - フィールドの値
 * @returns {Promise} バリデーション結果
 */
export const validatePostalCode = (_, value) => {
  const regex = /^[0-9]{7}$/;

  if (!value) {
    // 空の場合は、バリデーションを通過させる
    return Promise.resolve();
  } else if (!regex.test(value)) {
    return Promise.resolve();
    //   return Promise.reject(
    //     "郵便番号から住所を検索できませんでした。直接住所を入力してください"
    //   );
  }
  return Promise.resolve();
};

/**
 * パスワードのバリデーション
 * @param {object} rule - バリデーションルール
 * @param {string} value - フィールドの値
 * @returns {Promise} バリデーション結果
 */
export const validatePassword = (_, value) => {
  const passwordRegex = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[\W_]).{13,}$/;
  if (!value) {
    // 空の場合は、バリデーションを通過させる
    return Promise.resolve();
  } else if (!passwordRegex.test(value)) {
    return Promise.reject("パスワードを正しく入力してください");
  }

  return Promise.resolve();
};

/**
 * 認証番号のバリデーション
 * @param {object} rule - バリデーションルール
 * @param {string} value - フィールドの値
 * @returns {Promise} バリデーション結果
 */
export const validateCertificationNumber = (_, value) => {
  const certificationNumberRegex = /^(?=.*[0-9]).{6,6}$/;
  if (!value) {
    // 空の場合は、バリデーションを通過させる
    return Promise.resolve();
  } else if (!certificationNumberRegex.test(value)) {
    return Promise.reject("6桁の番号を入力してください");
  }

  return Promise.resolve();
};
